import { create } from "zustand"
import type { Grupa, Podgrupa, Artikal } from "../api/catalog"

interface CatalogState {
  grupe: Grupa[]
  podgrupe: Podgrupa[]
  artikli: Artikal[]
  loaded: boolean
  loading: boolean
  setCatalog: (g: Grupa[], p: Podgrupa[], a: Artikal[]) => void
  setLoading: (l: boolean) => void
  clear: () => void
}

export const useCatalogStore = create<CatalogState>((set) => ({
  grupe: [],
  podgrupe: [],
  artikli: [],
  loaded: false,
  loading: false,
  setCatalog: (grupe, podgrupe, artikli) => set({ grupe, podgrupe, artikli, loaded: true, loading: false }),
  setLoading: (loading) => set({ loading }),
  clear: () => set({ grupe: [], podgrupe: [], artikli: [], loaded: false })
}))
